<template>
        <b-container fluid style="padding-left: 40px; padding-right: 40px; height: 100%;">
            <parallax :fixed="true" style="min-height: 15vh; max-height: 100vh; height: auto !important;">
                <img src="../assets/parallax_trgovci_p.jpg" alt="" style="filter: brightness(60%);">
            </parallax>

            <div>
                <h1 style="color: white;">{{ $t('common.registration') }}</h1>
                <h4 style="color: white;">{{ $t('common.registration_2') }}</h4>
            </div>

            <b-card>
                <b-card-body>
                    <b-row align-h="center" >
                        <b-col style="background-color: #fff;">
                            <h3 style="padding-left: 40px;">{{ $t('common.title') }}</h3>
                        </b-col>
                    </b-row>
                    <b-row align-h="center" class="text-center " v-if="loaded" align-v="stretch">
                        <b-col style="padding-left: 50vh; padding-right: 50vh;" align-self="stretch" class="align-self-stretch">
                            <h3>{{ $t('login.unknown_certificate_1') }}</h3>
                            <h4>{{ $t('login.unknown_certificate_2') }}</h4>
                            <h4>{{ $t('login.unknown_certificate_3') }}</h4>
                        </b-col>
                    </b-row>
                    <b-row align-h="center" class="text-center" v-if="!loaded">
                        <b-col style="background-color: #f4f3ef;">
                            <h4>{{ $t('common.loading') }}</h4>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-container>
</template>

<script>
    import Parallax from 'vue-parallaxy'

    export default {
        name: "Login",
        components: {Parallax},
        data() {
            return {
                loaded: false
            }
        },
        methods: {
            auth() {
                this.$store.dispatch('auth')
                    .then(response => {
                        this.sslEnabled = response.data.sslEnabled;
                        if (!this.sslEnabled) {
                            // redirect to no cert page
                            this.$router.push('/home/noCertificate')
                        } else {
                            // go to IBAN input
                            this.$router.push('/home/IBANInput')
                        }
                    })
                    .catch(error => {
                      this.$store.commit('setError', error);
                    }).finally(()=>{
                        this.loaded = true;
                });
            },
        },
        watch: {
            '$route': 'auth'
        },
        created() {
            this.auth()
        }
    }
</script>

<style scoped>

</style>